import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=groupStrategy&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '集团战略（十五五）',
        pageTitleIcon: '',
        background_img: '',
        description: `华美致力于帮助酒店集团解决战略规划脱节、资源配置低效及增长动能不足等关键问题。很多集团面临战略方向模糊、架构冗杂或执行落地困难。华美结合国家政策与行业趋势，协助制定战略目标；通过组织诊断与资源评估，优化业务架构和管控模式；最后建立战略-执行-考核闭环机制，确保战略有效落地。`,
        icons: [
            {
                name: '集团战略',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/16.集团十五五.pdf'),
                path: "四库赋能-酒店+/集团战略（十五五）/集团战略"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/集团战略（十五五）/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/集团战略（十五五）/数据赋能'),
                path: "四库赋能-酒店+/集团战略（十五五）/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/集团战略（十五五）/全球案例/全球案例（集团战略（十五五））.xlsx'),
                path: "四库赋能-酒店+/集团战略（十五五）/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/集团战略（十五五）/预警问题/预警问题（集团战略（十五五））.xlsx'),
                path: "四库赋能-酒店+/集团战略（十五五）/预警问题"
            }
        ]
    }]
}